import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft, Search } from 'lucide-react';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      
      <div className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-2xl w-full text-center">
          {/* 404 Number */}
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-900 via-red-800 to-[#C0A062] animate-pulse">
              404
            </h1>
          </div>

          {/* Error Message */}
          <div className="mb-8">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Sayfa Bulunamadı
            </h2>
            <p className="text-xl text-gray-600 mb-2">
              Üzgünüz, aradığınız sayfa mevcut değil veya taşınmış olabilir.
            </p>
            <p className="text-lg text-gray-500">
              Lütfen URL'yi kontrol edin veya ana sayfaya dönün.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={() => navigate('/kolej')}
              className="bg-gradient-to-r from-red-900 to-red-800 hover:from-red-800 hover:to-red-700 text-white font-semibold px-8 py-6 rounded-full shadow-lg flex items-center justify-center gap-2"
            >
              <Home size={20} />
              Ana Sayfaya Dön
            </Button>
            
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              className="border-2 border-gray-300 hover:border-[#C0A062] text-gray-700 hover:text-[#C0A062] font-semibold px-8 py-6 rounded-full shadow-lg flex items-center justify-center gap-2"
            >
              <ArrowLeft size={20} />
              Geri Dön
            </Button>
          </div>

          {/* Helpful Links */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-gray-600 mb-4">Veya şu sayfaları ziyaret edebilirsiniz:</p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="/hakkimizda"
                className="text-[#C0A062] hover:text-[#9a7d4a] font-semibold transition-colors"
              >
                Hakkımızda
              </a>
              <span className="text-gray-400">•</span>
              <a
                href="/egitim-kademeleri"
                className="text-[#C0A062] hover:text-[#9a7d4a] font-semibold transition-colors"
              >
                Eğitim Kademeleri
              </a>
              <span className="text-gray-400">•</span>
              <a
                href="/kabul"
                className="text-[#C0A062] hover:text-[#9a7d4a] font-semibold transition-colors"
              >
                Kabul
              </a>
              <span className="text-gray-400">•</span>
              <a
                href="/iletisim"
                className="text-[#C0A062] hover:text-[#9a7d4a] font-semibold transition-colors"
              >
                İletişim
              </a>
            </div>
          </div>

          {/* Search Icon */}
          <div className="mt-12">
            <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gray-100">
              <Search className="w-12 h-12 text-gray-400" />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NotFoundPage;


